// extracted by mini-css-extract-plugin
module.exports = {"top":"top___3rBXC","left":"left___MUtCD","right":"right___2jgiW","title":"title___LzF-g"};